export const LANGUAGES = {
  EN: 'en',
  ES: 'es',
} as const;

export const LANGUAGE_LABELS = {
  EN: 'EN',
  ES: 'ES',
} as const;

export const CSS_CLASSES = {
  SLIDE_LEFT: 'slide-left',
  SLIDE_RIGHT: 'slide-right',
} as const;
